import './ShoppingCartPopup.less';

export const prefix = 'oc-c-shopping-cart-popup';

export { default } from './ShoppingCartPopup';